import { useState, useMemo } from "react";
import { TaxBreakdownResponse } from "../../model/CfdisNonIntegrated";
import {
  UseTaxBreakdownModalProps,
  UseTaxBreakdownModalResult,
  ProcessedBreakdownData,
  TaxBreakdownConfig
} from "./TaxBreakdownType";
import {
  processBreakdownData,
  generateModalConfig,
  isValidBreakdownData
} from "./taxBreakdownUtils";

export const useTaxBreakdownModal = ({
  data,
  type,
  context,
  paymentMethod,
  startDate,
  endDate,
  issuerName
}: UseTaxBreakdownModalProps): UseTaxBreakdownModalResult => {
    const [is_open, setIsOpen] = useState<boolean>(false);

  const processed_data: ProcessedBreakdownData = useMemo(() => {
    if (!isValidBreakdownData(data)) {
      return { 
        currencies: [], 
        is_empty: true, 
        show_cancellation_section: false 
      };
    }

    return processBreakdownData(data, type, context);
  }, [data, type, context]);

  const config: TaxBreakdownConfig = useMemo(() => {
    return generateModalConfig(
      type,
      context,
      paymentMethod,
      startDate,
      endDate,
      issuerName
    );
  }, [type, context, paymentMethod, startDate, endDate, issuerName]);

  const open_modal = () => {
    setIsOpen(true);
  };

  const close_modal = () => {
    setIsOpen(false);
  };

  return {
    processed_data,
    config,
    is_open,
    open_modal,
    close_modal
  };
};

export const useSimpleTaxBreakdownModal = () => {
  const [is_open, setIsOpen] = useState<boolean>(false);
  const [modal_data, setModalData] = useState<{
    data?: TaxBreakdownResponse;
    type: 'transfers' | 'withholdings';
    context: 'general' | 'unregistered' | 'issuer';
    payment_method: string;  
    start_date: string;   
    end_date: string;        
    issuer_name?: string;    
  } | null>(null);

  const open_modal = (
    type: 'transfers' | 'withholdings',
    context: 'general' | 'unregistered' | 'issuer',
    data: TaxBreakdownResponse | undefined,
    payment_method: string,
    start_date: string,
    end_date: string,
    issuer_name?: string
  ) => {
    setModalData({
      data,
      type,
      context,
      payment_method,
      start_date,
      end_date,
      issuer_name
    });
    setIsOpen(true);
  };

  const close_modal = () => {
    setIsOpen(false);
    setTimeout(() => {
      setModalData(null);
    }, 200);
  };

  return {
    is_open,
    modal_data,
    open_modal,
    close_modal
  };
};